/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import FilterSelect from "./filterselect";
import InputAutocomplete from "./inputautocomplete";
import {getOptionsQuery} from "../../../common/api";
import moment from "moment";
import {ts_translate} from "../../../common/clientTranslate";

const Wrapper = styled.div`
	display flex;
	justify-content: flex-end;
	align-items: flex-end;
	margin-right: 9px;
`;

const Info = styled.div`
	font-size: 8px;
	color: #95989a;
	margin-right: 9px;
`;

const FilterButton = styled.button`
	min-height: 25px;
    min-width: 25px;
    border: none;
    background-color: white;
    margin: 0 10px;
`;

const FilterInput = styled.input`
    color: #686871;
    padding: 1px;
`;

class BarFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {erp: '', order: '', filter: '', custom: '', options: []};

        this.handleErpChange = this.handleErpChange.bind(this);
        this.handleOrderChange = this.handleOrderChange.bind(this);
        this.handleCustomChange = this.handleCustomChange.bind(this);
    }

    handleErpChange(event) {
        this.setState({erp: event.target.value});
    }

    handleOrderChange(event) {
        this.setState({order: event.target.value});
    }

    handleCustomChange(value) {
        // this.setState({custom: event.target.value});
        this.setState({custom: value});
    }

    clear() {
        const {filter} = this.props;
        this.setState({erp: '', order: '', custom: '', options: []});
        filter(this.state.filter, '');
        // this.props.filter('', '');
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.doFilter();
            // filter(this.state.erp, this.state.order)
        }
    }

    setFilter = (filter) => {
        this.setState({filter: filter});
    }

    doFilter = () => {
        const {filter} = this.props;
        this.setState({options: []});
        filter(this.state.filter, this.state.custom)
    }

    requestOptions = (value) => {

        if (this.state.filter.value === 'order_number'){
            this.setState({options: [ts_translate('Leider keine Autovervollständigung verfügbar.')]});
            return new Promise((resolve, reject) => {
                resolve();
            })
        }
        const {pagingValue} = this.props;
        const start = moment(pagingValue).startOf('week').subtract(3, 'hour').format('YYYY-MM-DD');
        const end = moment(pagingValue).startOf('week').add(5, 'day').format('YYYY-MM-DD');
        const query = {
            search: `date>${start}T23:00:00.000+01:00,date<${end}T01:00:00.000+01:00,` + this.state.filter.value + '%' + value,
            size: 1000, projection: 'details'
        };
        return getOptionsQuery('/task/search/dslquery', query).then(response => {
            if (response.data['_embedded']) {
                let responseValues = R.uniq(R.pluck(this.state.filter.value, response.data['_embedded'].task));
                this.setState({options: responseValues});
            } else {
                this.setState({options: []});
            }
        });
    }

    render() {
        return (
            <Wrapper>
                {/*<Info>
                    {ts_translate('ERP-Nummer')} Filter:
                </Info>

                <FilterInput value={this.state.erp} onChange={this.handleErpChange} onKeyDown={this.handleKeyDown}/>

                <span>&nbsp;</span>

                <Info>
                    {ts_translate('Order-Nummer')} Filter:
                </Info>

                <FilterInput value={this.state.order} onChange={this.handleOrderChange} onKeyDown={this.handleKeyDown}/>

                <span>&nbsp;</span>*/}

                <FilterSelect setFilter={this.setFilter}/>
                <span>&nbsp;</span>
                {/*<FilterInput value={this.state.custom} onChange={this.handleCustomChange} onKeyDown={this.handleKeyDown}/>*/}
                <InputAutocomplete value={this.state.custom} onChange={this.handleCustomChange}
                                   onKeyDown={this.handleKeyDown} requestOptions={this.requestOptions}
                                   options={this.state.options} onSelect={this.doFilter}/>
                <span>&nbsp;</span>


                <FilterButton onClick={() => this.doFilter()}>
                    <FontAwesomeIcon size="1x" icon={faSearch} color="#686871"/>
                </FilterButton>

                <FilterButton onClick={() => this.clear()}>
                    <FontAwesomeIcon size="1x" icon={faTrashAlt} color="#686871"/>
                </FilterButton>
            </Wrapper>
        );
    }
}

export default BarFilter;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/filter.js